// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__yn_7G","title":"AfterFrontImage_title__QVpSa"};